import styled from 'styled-components';
export const Textiles = styled.div `
    ul,
    ol {
        padding-left: 2.5rem;

        &.ul-level-0,
        &.ol-level-0 {
            margin: 1rem 0;
        }
    }

    ul {
        &.ul-level-1 li {
            list-style-type: circle;
        }

        &.ul-level-2 li {
            list-style-type: square;
        }

        &.ul-level-3 li {
            list-style-type: disc;
        }
    }

    ol {
        li {
            position: relative;
        }

        &.ol-level-1 {
            list-style-type: lower-alpha;
        }

        &.ol-level-2 {
            list-style-type: lower-roman;
        }

        &.ol-level-3 {
            list-style-type: decimal;
        }
    }

    > p {
        white-space: pre-wrap;
        margin: 1rem 0;
    }

    p:empty:before {
        content: ' ';
        white-space: pre;
    }

    a {
        color: ${(props) => props.theme.colors.primary};
    }

    p > code {
        background-color: ${(props) => props.theme.colors.codeBackground};
        font-size: 16px;
        padding: 2px;
    }

    pre {
        background-color: ${(props) => props.theme.colors.codeBackground};
        font-size: 16px;
        padding: 20px;
        overflow-x: auto;
    }
`;
//# sourceMappingURL=index.style.js.map